import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../../../../../services/account/account.service';
import { Router } from '@angular/router';
import { LocationDefaultStaffSiteEventsView } from '../../../../../../models/location';


@Component({
  selector: 'app-scheduled-events-default-redirect',
  templateUrl: './scheduled-events-default-redirect.component.html',
  styleUrls: ['./scheduled-events-default-redirect.component.css']
})
export class ScheduledEventsDefaultRedirectComponent implements OnInit {

  constructor(
    private accountService: AccountService,
    private router: Router,
  ) {}

  ngOnInit() {
    switch (this.accountService.getMyAccount().default_gym_default_staff_site_events_view) {
      case LocationDefaultStaffSiteEventsView.calendar:
        this.router.navigate(
          ['/events/scheduled/calendar'],
          {
            replaceUrl: true
          }
        );
        break;
      default:
        this.router.navigate(
          ['/events/scheduled/now'],
          {
            replaceUrl: true
          }
        );
    }
  }

}
